<template lang="pug">
  v-container.grey--text.text--darken-3
    h2.grey--text.text--darken-3 Cobranzas

    // Customers List
    v-expansion-panel
      v-expansion-panel-content(
        v-for="customer in customers"
        :key="customer.id"
        )
        div(slot="header")
          h3.grey--text.text--darken-3 {{customer.business_name}}
          h3.grey--text.text--darken-3 {{customer.rut}}
        v-card
          v-flex.xs12.px-4.pb-2
            b Cupo Máximo: {{!customer.max_customer_credit_amount ? 'Sin Crédito' : ''}}
            b(
              v-if="customer.max_customer_credit_amount"
              ) {{customer.max_customer_credit_amount | mixFormatCurrency}} 
          v-flex.xs12.px-4.pb-2(
            v-if="customer.max_customer_credit_amount"
            )
            b Cupo Disponible: 
            b {{customer.max_customer_credit_amount - customer.receivable | mixFormatCurrency}} 
          v-flex.xs12.px-4.pb-2
            b Deuda Total: {{customer.receivable | mixFormatCurrency}} 
          v-flex.xs12.px-4.pb-2
            b Monto Atrasado: {{customer.defaulter_amount | mixFormatCurrency}} 
          v-flex.xs12.px-4.pb-2
            b Próximo Vencimiento: 
            b(
              :class="customer.defaulter_amount ? ['red--text'] : []"
              ) {{customer.next_pay_date | ddmmyyyy}} 
          v-flex.xs12.px-4.pb-2
            v-btn(
              small
              block
              :color="colors.secondary"
              @click="activeCustomer = customer"
              dark) Ver Facturas

    // Invoices Modal
    v-dialog(
      v-model="showInvoicesDialog"
      v-if="activeCustomer"
      fullscreen
      )
        v-toolbar(:color="colors.secondary" dark).d-flex
          span.title Facturas {{activeCustomer.business_name}}
          v-btn(
            icon
            @click="showInvoicesDialog = false"
            )
            v-icon close
        v-card
          v-container(style="height: calc(100vh - 48px); overflow: auto;")
            .blocker(
              v-if="invoiceDetailLoading"
              )

            // Invoice Details
            v-expansion-panel.font-weight-bold(
              v-if="activeCustomer.invoices && activeCustomer.invoices.length"
              v-model="activeInvoiceIndex"
              )
              v-expansion-panel-content.blue-grey.lighten-4(
                v-for="invoice in activeCustomer.invoices"
                :key="invoice.id"
                )
                v-layout.grey--text.text--darken-3(
                  slot="header"
                  wrap
                  ) 
                  v-flex.xs6 # {{invoice.sl_sale_invoice.number}}
                  v-flex.xs6 {{invoice.amount | mixFormatCurrency}}
                  v-flex.xs6 {{invoice.sl_sale_invoice.created_at | createdAtddmmyyyy}}
                  v-flex.xs6 {{invoice.pay_date | ddmmyyyy}}
                  v-progress-linear( 
                    style="position: absolute; margin-top: 48px; left: 0px;"
                    indeterminate
                    v-if="invoiceDetailLoading"
                    )

                v-list(
                  v-if="activeInvoiceDetails && activeInvoiceDetails.length"
                  )
                  v-list-tile(v-for="detail in activeInvoiceDetails")
                    MobileCartItem(:item="formatSaleDetail(detail)") 
            h2.text-xs-center.grey--text.text-darken-2(v-else) 
              | No se encontraron facturas para este cliente
    span.text-xs-center(v-if="!customers.length") No se encontraron cobranzas para sus clientes
</template>

<script>
import SlGroundSellerCustomerReceivable from '../../models/Sale/SlGroundSellerCustomerReceivable'
import CurrencyUtils from '../../mixins/CurrencyUtils'
import { mapGetters } from 'vuex'
import { flow, sortBy, minBy, reduce, map } from 'lodash'
import SlSaleInvoice from '../../models/Sale/SlSaleInvoice'
import MobileCartItem from '../MobileCart/MobileCartItem'
import GUser from '@/models/General/GUser'
export default {
    name: 'ground-seller-receivables',
    components: { MobileCartItem },
    mixins: [CurrencyUtils],
    data: () => ({
        customers: [],
        activeCustomer: null,
        showInvoiceDetails: null,
        invoiceDetailLoading: false,
        activeInvoiceDetails: [],
        activeInvoiceIndex: null,
    }),
    computed: {
        ...mapGetters('AuthModule', {
            groundSellerId: 'groundSellerId',
        }),
        showInvoicesDialog: {
            get() {
                return !!this.activeCustomer
            },
            set(v) {
                if (!v) {
                    this.activeCustomer = null
                    this.resetInvoicesModal()
                }
            },
        },
    },
    methods: {
        formatCustomers: customers =>
            map(customers, c => {
                if (!c.invoices.length) return c
                c.invoices = sortBy(c.invoices, i =>
                    new Date(i.pay_date).getTime()
                )
                c.defaulter_amount = c.invoices.reduce(
                    (da, i) =>
                        (da +=
                            new Date(i.pay_date).getTime() <
                            new Date().getTime()
                                ? i.amount
                                : 0),
                    0
                )
                c.next_pay_date = c.invoices[0].pay_date
                return c
            }),
        formatSaleDetail(detail) {
            return {
                name: detail.wh_product.name,
                alias_name: detail.wh_product.alias_name,
                quantity: detail.quantity,
                sale_price: Math.round(detail.net_price * 1.19),
                subtotal: Math.round(detail.subtotal * 1.19),
            }
        },
        resetInvoicesModal() {
            Object.assign(this.$data, {
                activeCustomer: null,
                showInvoiceDetails: null,
                invoiceDetailLoading: false,
                activeInvoiceDetails: [],
                activeInvoiceIndex: null,
            })
        },
    },
    filters: {
        ddmmyyyy: d =>
            d
                .split('-')
                .reverse()
                .join('-'),
        createdAtddmmyyyy: ca =>
            ca
                .split(' ')[0]
                .split('-')
                .reverse()
                .join('-'),
    },
    watch: {
        activeInvoiceIndex(v) {
            if (!v && v !== 0) {
                this.activeInvoiceDetails = []
                return
            }
            this.invoiceDetailLoading = true
            new SlSaleInvoice()
                .include('sl_detail_sale_invoices.wh_product')
                .find(this.activeCustomer.invoices[v].sl_sale_invoice_id)
                .then(r => {
                    this.activeInvoiceDetails = r.sl_detail_sale_invoices
                    this.invoiceDetailLoading = false
                })
                .catch(console.log)
        },
    },
    mounted() {
        let id = this.groundSellerId
        new GUser()
            .append('ground_seller_id')
            .find(id)
            .then(r => r)
            .catch(console.log)
            .then(r => {
                new SlGroundSellerCustomerReceivable()
                    .params({ sl_ground_seller_id: r.ground_seller_id })
                    .where('customer_with_debts', 1)
                    .get()
                    .then(
                        r =>
                            (this.customers =
                                r && r.length
                                    ? this.formatCustomers(r[0].customers)
                                    : [])
                    )
                    .catch(console.log)
            })
            .catch(console.log)
    },
}
</script>

<style scoped>
.blocker {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    z-index: 20;
}
</style>
